
export default function () {    
console.log('Holaaaa')
  window.localStorage.clear()
  window.location.href = '/login'
}
